import React from 'react'
import { Link } from 'react-router-dom'
import { hrefFor } from '../twoHost'

/**
 * A link that may cross between praenum.com and app.praenum.com (ADR-0062).
 *
 * A router <Link> when the target is on this host. A plain <a> with an absolute
 * URL when it is on the other one, because a <Link> renders the next page
 * without a request, on this origin, which is the wrong one. Use it for every
 * link between the marketing pages and the app; an ordinary <Link> is fine for
 * one that stays on its own side.
 */
export default function HostLink({ to, children, ...rest }) {
  const href = hrefFor(to)
  if (href !== to) {
    return <a href={href} {...rest}>{children}</a>
  }
  return <Link to={to} {...rest}>{children}</Link>
}
